var _ellipse, _path, _rect, _rect2, _rect3, _polygon, _path2, _path3, _ellipse2, _path4, _circle, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _rect4, _rect5, _circle2, _polygon2, _path21, _path22, _circle3, _polygon3, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _circle4, _path30, _path31, _path32, _circle5, _path33, _circle6, _ellipse3, _ellipse4, _path34;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndrawReviewFkgn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a62e712f-3cb4-4d7a-829a-d896e102ddef",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 990.06175,
    height: 695.36453,
    viewBox: "0 0 990.06175 695.36453",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "review") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 155,
    cy: 683.36453,
    rx: 155,
    ry: 12,
    fill: "#6c63ff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M229.227,130.64925l-.13277-.73539-12.57243-6.659h-1.973l-.75465-1.44633H187.88383l-6.00851,1.44633h-22.129l-5.995,6.99605-.06134.42893c-.38811,2.50226-9.05914,61.34071,13.81854,80.06159l9.53913,4.43257h6.16871l-1.20584-2.40775,5.3627,2.40775h17.3625l.30844-.46278,10.30313-3.85746.26555-.30638C216.54223,209.4444,238.43936,182.83887,229.227,130.64925Z",
    transform: "translate(-104.96912 -102.31774)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 82.9147,
    y: 86.81252,
    width: 10.21324,
    height: 26.55442,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 78.31875,
    y: 147.58129,
    width: 18.38383,
    height: 510.66189,
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 73.72279,
    y: 138.90003,
    width: 27.57574,
    height: 17.3625,
    fill: "#3f3d56"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "63.51 107.239 80.872 125.623 73.723 138.9 88.021 141.964 101.299 138.9 93.128 124.602 109.469 107.239 63.51 107.239",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.20147,130.9148l-8.17059-8.17059,6.12794-6.12794h77.62061l6.12794,7.14927-9.19191,7.14926S178.69191,128.87215,155.20147,130.9148Z",
    transform: "translate(-104.96912 -102.31774)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M229.227,130.64925l-.13277-.73539-12.57243-6.659-5.74-3.04358L178.55914,118.138l-18.06729,4.24868-.74554.86816-5.995,6.99605-.06134.42893c-.38811,2.50226-9.05914,61.34071,13.81854,80.06159l9.53913,4.43257,8.02759,3.7278-1.85888-3.7278-3.05375-6.09733c-3.19662-18.60849-10.22346-67.49926-5.73971-77.71249l18.5267-5.97478L209.393,131.497c1.13353,7.34332,8.46669,58.82823-4.38152,77.18145l-.27578.39827v5.75006l10.61157-3.973.26555-.30638C216.54223,209.4444,238.43936,182.83887,229.227,130.64925Zm-15.72828,77.62061-5.69907,2.14475v-.38811c14.09432-21.029,4.882-77.49805,4.48363-79.90836l-.143-.87832-16.11652-5.985-2.99241-1.11327-3.4522,1.11327-17.28072,5.57639-.29623.52089c-6.567,11.77589,4.69819,77.6615,5.17818,80.45991l.0409.22467,1.21531,2.43075-9.14079-4.21807c-20.37549-16.96417-13.38967-71.28839-12.64412-76.67079l5.5153-6.43432,8.02746-1.88943,8.63026-2.03242,14.20665.91915,16.89274,1.09283.04076.02044,16.37185,8.66081C234.44607,179.254,215.83746,205.24671,213.49871,208.26986Z",
    transform: "translate(-104.96912 -102.31774)",
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.02132,
    cy: 14.29853,
    rx: 27.57574,
    ry: 14.29853,
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M178.69191,734.51716l-16.34118,52.08751s25.5331,14.29853,60.25811,0l-16.34118-52.08751Z",
    transform: "translate(-104.96912 -102.31774)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88.02132,
    cy: 81.7059,
    r: 8.17059,
    fill: "#6c63ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M494.40733,485.5453c4.31577,15.95369,19.09826,25.83421,19.09826,25.83421s7.78525-15.98552,3.46948-31.9392S497.8768,453.6061,497.8768,453.6061,490.09156,469.59162,494.40733,485.5453Z",
    transform: "translate(-104.96912 -102.31774)",
    fill: "#6c63ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M500.74905,482.11669c11.84254,11.52823,13.289,29.24981,13.289,29.24981s-17.75407-.96938-29.59661-12.49761-13.289-29.24982-13.289-29.24982S488.90651,470.58845,500.74905,482.11669Z",
    transform: "translate(-104.96912 -102.31774)",
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1085.38624,482.38394,672.33745,599.50684l376.85389-212.34267a378.38426,378.38426,0,0,0-64.05755-85.75425L619.50077,502.6396,925.59973,252.693a374.85754,374.85754,0,0,0-145.35632-57.14274L610.69465,478.62293l112.295-288.15326c-1.672-.02184-3.34329-.04681-5.02053-.04681-208.24544,0-377.06175,168.81621-377.06175,377.06175a375.30179,375.30179,0,0,0,54.47786,195.3356H1040.553a378.25522,378.25522,0,0,0,44.83322-280.43627Z",
    transform: "translate(-104.96912 -102.31774)",
    fill: "#f2f2f2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.96912,727.61136c0-32.1668-16.3221-58.24316-36.45652-58.24316-12.655,0-23.8005,10.30532-30.33731,25.94558a18.28713,18.28713,0,0,0-6.967-1.398c-6.09437,0-11.72912,3.12278-16.32427,8.40786-5.89245-19.501-18.38733-32.95544-32.84964-32.95544-13.52216,0-25.316,11.77072-31.60967,29.23969a19.91515,19.91515,0,0,0-12.47729-4.69211c-15.45192,0-27.97826,20.012-27.97826,44.69822a65.14484,65.14484,0,0,0,4.40793,24.06826h183.23973C1050.23014,752.926,1052.96912,740.78108,1052.96912,727.61136Z",
    transform: "translate(-104.96912 -102.31774)",
    fill: "#6c63ff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M684.34578,336.124v-.00015A140.89768,140.89768,0,0,1,825.24345,195.22619",
    transform: "translate(-104.96912 -102.31774)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M735.61122,354.56505c-11.2859,41.71946-49.94264,67.55737-49.94264,67.55737s-20.35869-41.8027-9.07279-83.52215,49.94264-67.55737,49.94264-67.55737S746.89712,312.8456,735.61122,354.56505Z",
    transform: "translate(-104.96912 -102.31774)",
    fill: "#6c63ff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M632.941,354.56505c11.28589,41.71946,49.94264,67.55737,49.94264,67.55737s20.35869-41.8027,9.07279-83.52215-49.94264-67.55737-49.94264-67.55737S621.65514,312.8456,632.941,354.56505Z",
    transform: "translate(-104.96912 -102.31774)",
    fill: "#6c63ff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M649.52487,345.59909c30.96866,30.14675,34.75126,76.48932,34.75126,76.48932s-46.42753-2.535-77.39619-32.68172-34.75127-76.48931-34.75127-76.48931S618.5562,315.45235,649.52487,345.59909Z",
    transform: "translate(-104.96912 -102.31774)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M719.02739,345.59909c-30.96866,30.14675-34.75126,76.48932-34.75126,76.48932s46.42753-2.535,77.39619-32.68172,34.75127-76.48931,34.75127-76.48931S749.99606,315.45235,719.02739,345.59909Z",
    transform: "translate(-104.96912 -102.31774)",
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M802.42206,225.36315c5.00195-18.4902,22.13474-29.94164,22.13474-29.94164s9.023,18.52708,4.02109,37.01728-22.13474,29.94164-22.13474,29.94164S797.42012,243.85334,802.42206,225.36315Z",
    transform: "translate(-104.96912 -102.31774)",
    fill: "#6c63ff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M847.92582,225.36315c-5.002-18.4902-22.13474-29.94164-22.13474-29.94164s-9.023,18.52708-4.02109,37.01728,22.13473,29.94164,22.13473,29.94164S852.92776,243.85334,847.92582,225.36315Z",
    transform: "translate(-104.96912 -102.31774)",
    fill: "#6c63ff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M840.57581,229.33689c-13.72541-13.36114-15.40187-33.90031-15.40187-33.90031s20.57683,1.12351,34.30224,14.48464,15.40187,33.90031,15.40187,33.90031S854.30122,242.698,840.57581,229.33689Z",
    transform: "translate(-104.96912 -102.31774)",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M809.77207,229.33689c13.72541-13.36114,15.40187-33.90031,15.40187-33.90031s-20.57683,1.12351-34.30224,14.48464-15.40187,33.90031-15.40187,33.90031S796.04666,242.698,809.77207,229.33689Z",
    transform: "translate(-104.96912 -102.31774)",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M975.74807,605.91129H958.9364V512.78282a9.63494,9.63494,0,0,0-9.60667-9.60667h-28.82V421.20827a9.63491,9.63491,0,0,0-9.60667-9.60667H462.59184a9.6349,9.6349,0,0,0-9.60667,9.60667v81.96788h-28.82a9.63494,9.63494,0,0,0-9.60667,9.60667v93.12847H397.74683a9.6349,9.6349,0,0,0-9.60667,9.60667V753.21355a9.63493,9.63493,0,0,0,9.60667,9.60666H975.74807a9.63493,9.63493,0,0,0,9.60667-9.60666V615.518A9.6349,9.6349,0,0,0,975.74807,605.91129Z",
    transform: "translate(-104.96912 -102.31774)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M891.74486,576.79957c-8.8278,13.972-6.10192,31.5423-6.10192,31.5423s17.03857-5.08272,25.86636-19.05469,6.10192-31.54229,6.10192-31.54229S900.57265,562.8276,891.74486,576.79957Z",
    transform: "translate(-104.96912 -102.31774)",
    fill: "#6c63ff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M898.56027,579.14967c-.47656,16.52025-12.54749,29.5755-12.54749,29.5755s-11.29826-13.72938-10.8217-30.24964S887.73857,548.9,887.73857,548.9,899.03684,562.62941,898.56027,579.14967Z",
    transform: "translate(-104.96912 -102.31774)",
    fill: "#e6e6e6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 309.58937,
    y: 503.59355,
    width: 544.3779,
    height: 9.60667,
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 348.01605,
    y: 401.12242,
    width: 467.52455,
    height: 9.60667,
    fill: "#e6e6e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 720.27447,
    cy: 167.36014,
    r: 9.60667,
    fill: "#6c63ff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "412.411 390.687 665.405 318.833 703.108 451.582 684.831 456.773 698.765 505.833 635.771 470.707 450.114 523.437 412.411 390.687",
    fill: "#6c63ff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M670.79911,551.86692l-5.60781-2.75918c-19.98646-10.05224-33.13524-16.52648-36.47744-28.29414a17.403,17.403,0,0,1,12.09268-21.84176,18.93042,18.93042,0,0,1,15.69934,2.56962,18.92964,18.92964,0,0,1,12.00494-10.43807,17.403,17.403,0,0,1,21.76811,12.22475c3.34225,11.7678-4.44066,24.187-16.15951,43.24388Z",
    transform: "translate(-104.96912 -102.31774)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M221.79523,420.46254s-6.49095,19.47287-2.88487,23.80018-21.63653-12.98192-21.63653-12.98192L210.977,415.414Z",
    transform: "translate(-104.96912 -102.31774)",
    fill: "#a0616a"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.02366,
    cy: 285.73182,
    r: 32.38133,
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "227.894 537.395 211.306 550.377 201.93 535.231 218.518 523.692 227.894 537.395",
    fill: "#a0616a"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M309.42318,737.4377l4.32731,20.91531,12.2607,16.588s33.176,10.097,10.81826,15.14557-27.40627-3.60608-27.40627-3.60608l-15.86679-13.70314V791.529H283.45934l-2.16365-26.685s-1.44243-7.9334,5.04853-16.588l1.44243-12.98192Z",
    transform: "translate(-104.96912 -102.31774)",
    fill: "#2f2e41"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M225.76193,478.52056l5.76974,33.176s61.3035-6.491,65.63081,5.76974,5.76974,15.86679,5.76974,15.86679l-12.2607,4.3273-5.76974-10.81826a13.69822,13.69822,0,0,0-10.81827.72122c-5.76974,2.88487-56.255,10.097-59.86106.72121s-13.70314-43.99427-13.70314-43.99427l15.14557-12.2607Z",
    transform: "translate(-104.96912 -102.31774)",
    fill: "#a0616a"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M225.76193,478.52056l5.76974,33.176s61.3035-6.491,65.63081,5.76974,5.76974,15.86679,5.76974,15.86679l-12.2607,4.3273-5.76974-10.81826a13.69822,13.69822,0,0,0-10.81827.72122c-5.76974,2.88487-56.255,10.097-59.86106.72121s-13.70314-43.99427-13.70314-43.99427l15.14557-12.2607Z",
    transform: "translate(-104.96912 -102.31774)",
    opacity: 0.1
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M259.65916,574.4425l5.04853,17.30923,12.98191,66.352s1.44244,49.0428,3.60609,54.81254,2.16365,6.491,0,8.65462-6.491,9.37583,0,13.70313,29.56993,9.37583,30.29114,4.32731.72122-12.98192,0-16.588,2.16366-59.86106,2.16366-59.86106l-8.65462-85.8249L275.526,563.62424Z",
    transform: "translate(-104.96912 -102.31774)",
    fill: "#2f2e41"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M259.65916,574.4425l5.04853,17.30923,12.98191,66.352s1.44244,49.0428,3.60609,54.81254,2.16365,6.491,0,8.65462-6.491,9.37583,0,13.70313,29.56993,9.37583,30.29114,4.32731.72122-12.98192,0-16.588,2.16366-59.86106,2.16366-59.86106l-8.65462-85.8249L275.526,563.62424Z",
    transform: "translate(-104.96912 -102.31774)",
    opacity: 0.1
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M290.67152,506.64805l15.86679,30.29114s90.87342,40.38819,82.94,56.97619-51.92767,47.60037-51.92767,47.60037-2.16365,12.2607-8.65461,8.65461-22.35775-22.35775-20.91532-24.5214,6.491-7.21218,8.65462-6.491,27.40627-18.75166,27.40627-18.75166l-43.27306-10.81826s-51.92767-1.44244-54.81254-25.96384,0-28.84871,0-28.84871l-3.60609-7.93339,29.56992-18.03044Z",
    transform: "translate(-104.96912 -102.31774)",
    fill: "#2f2e41"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M313.02927,626.37018,297.8837,640.07331s-12.98192-5.76974-20.91531-3.60609-21.63653,3.60609-21.63653,3.60609l2.16365,12.2607,18.401-3.39483L261.1016,669.64324s0,32.45479,9.37583,32.45479,6.491-19.47288,6.491-19.47288l28.8487-22.35774s14.42435-5.76975,15.86679-5.76975S313.02927,626.37018,313.02927,626.37018Z",
    transform: "translate(-104.96912 -102.31774)",
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.94124,
    cy: 299.39314,
    r: 24.5214,
    fill: "#a0616a"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M194.74957,420.82314s11.53949-2.88487,15.14557,0,4.32731,9.37583,9.37583,10.097,9.37583.72122,10.097,1.44244,17.30922,20.91531,17.30922,20.91531,10.097,5.76974,12.2607,13.70313,23.80019,34.61845,26.68506,37.50332-18.75166,17.30923-25.96384,22.35775-28.12749,7.21218-34.61845-4.32731S183.21009,435.96871,194.74957,420.82314Z",
    transform: "translate(-104.96912 -102.31774)",
    fill: "#575a89"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M222.15584,467.70229l5.76974,33.176s61.30351-6.491,65.63081,5.76975,5.76974,15.86678,5.76974,15.86678l-12.2607,4.32731-5.76974-10.81827a13.6982,13.6982,0,0,0-10.81826.72122c-5.76974,2.88487-56.255,10.097-59.86107.72122S196.91323,473.472,196.91323,473.472l15.14557-12.2607Z",
    transform: "translate(-104.96912 -102.31774)",
    fill: "#a0616a"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M208.3735,423.85753s17.38843,36.63259,15.946,46.72963-6.491,2.88487-6.491,2.88487-6.491-10.097-9.37583-4.3273-6.491,13.70313-9.37583,12.98191-18.75166-54.09132-10.097-59.13984S208.3735,423.85753,208.3735,423.85753Z",
    transform: "translate(-104.96912 -102.31774)",
    fill: "#575a89"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.94388,
    cy: 243.0964,
    r: 32.38133,
    fill: "#2f2e41"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M143.98238,372.228a32.38308,32.38308,0,0,0,50.00535-17.00289,32.38312,32.38312,0,1,1-63.16725-13.27935A32.37117,32.37117,0,0,0,143.98238,372.228Z",
    transform: "translate(-104.96912 -102.31774)",
    fill: "#2f2e41"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.38864,
    cy: 291.1287,
    r: 23.74631,
    fill: "#2f2e41"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.35712,
    cy: 282.22382,
    rx: 21.04786,
    ry: 16.46051,
    fill: "#2f2e41"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.30185,
    cy: 301.9174,
    rx: 4.68791,
    ry: 8.294,
    fill: "#a0616a"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M283.62119,526.527s12.76753-7.32507,15.13776-5.48829,3.4233,7.58439,3.4233,7.58439L287.426,534.41492l-4.3273-7.93339Z",
    transform: "translate(-104.96912 -102.31774)",
    fill: "#2f2e41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawReviewFkgn);
export default __webpack_public_path__ + "static/media/undraw_review_fkgn.62d7704a.svg";
export { ForwardRef as ReactComponent };